define('app/models/discount',['app/setup'], function(takhfifan) {

  takhfifan.Discount = Backbone.Model.extend({
    defaults: {
      sold: 0,
      available: 0
    },
    urlRoot: '/ajax/product/discountElement',

    initialize: function (options) {
      var _this = this;
      if (options && 'vendorId' in options) {
        this.vendorId = options.vendorId;
      }
    },

    parse: function (resp, xhr) {
      var price = parseInt(resp.price, 10) / 10,
        rp = parseInt(resp.retailPrice, 10) / 10,
        discount = Math.round((1 - (price / rp)) * 100);

      this.set({
        'id': resp.id,
        'vendorId': resp.vendorId,
        'name': resp.name,
        'image': resp.image,
        'shortTitle': resp.shortTitle,
        'nameOriginal': resp.nameOriginal,
        'discountPercentage': resp.discountPercentage,
        'couponBadgeContent': resp.couponBadgeContent,
        'dealType': resp.dealType,
        'maxPerOrder': resp.maxPerOrder,
        'countView': resp.countView,
        'dealHighlights': resp.dealHighlights,
        'productLike': resp.productLike,
        'sold': parseInt(resp.sold),
        'available': parseInt(resp.available),
        'expired': resp.expired,
        'isSoldOut': resp.isSoldOut,
        'allowedProductsPrices': resp.allowedProductsPrices,
        'seconds': resp.seconds,
        'partnerUrl': resp.partnerUrl,
        'dealCondition': resp.dealCondition,
        'price': price,
        'retailPrice': rp,
        'discount': discount
      });

      takhfifan.eventHub.trigger('dealseconds:' + this.get('id'), parseInt(resp.seconds));
      takhfifan.eventHub.trigger('cartinfo:' + this.get('id'), this);

      if (this.get('expired') || this.get('isSoldOut')) {
        takhfifan.eventHub.trigger('groupedProduct:removeAssociate', {
          productId: this.get('id')
        });
      }
      if (this.get('isSoldOut')) {
        takhfifan.eventHub.trigger('buyButton:soldOut', this);
      }
      if (this.get('allowedProductsPrices')) {
        _tkhProductPrices = this.get('allowedProductsPrices');
        if(_.isEmpty(_tkhProductPrices)){
          takhfifan.eventHub.trigger('buyButton:soldOut', this);
        }else{
          var availableItems = 0;
          _.each(_tkhProductPrices, function(item, itemId){
            if(!item.isSoldOut && !item.isExpired){
              takhfifan.eventHub.trigger('configurableItemSetup:'+ itemId);
              availableItems++;
            }
          });
          if(availableItems === 0){
            takhfifan.eventHub.trigger('buyButton:soldOut', this);
          }
        }
      }
    },

    checkIfCustomerCanBuy: function (formKey, checkUrl, callBack) {
      var result = false;
      $.ajax({
        url: checkUrl,
        type: "GET",
        data: {
          pid: this.id,
          form_key: formKey
        }
      }).done(function (data) {
        if (data.success) {
          result = true;
        }
      }).fail(function () {
        throw new Error(i18n.t('connection_error_notify'));
      }).always(function () {
        callBack(result);
      });

    },

    getCheckoutType: function (formKey, checkUrl, resultCallback) {
      var _this = this;
      try {
        this.checkIfCustomerCanBuy(formKey, checkUrl, function (canBuy) {
          var result = {success: false, error: '', type: null, code: null};
          if (canBuy) {
            if (!_this.get('price') || _this.get('price') == 0) {
              $.ajax({
                url: '/ajax/coupon/getCouponByPid',
                type: 'POST',
                data: {
                  pid: _this.id
                }
              }).done(function (data) {
                if (data.success) {
                  if (data.message.is_multiple == '1') {
                    if (data.message.code) {
                      result.success = true;
                      result.type = 'multi';
                      result.code = data.message.code;
                    } else {
                      result.error = i18n.t('coupon_code_read_error');
                    }
                  } else {
                    result.success = true;
                    if(data.message.is_free === '1'){
                      result.id = data.message.id;
                      result.type = 'free';
                    } else{
                      result.type = 'cart';
                    }
                  }
                } else if (data.code == 404) {
                  result.success = true;
                  result.type = 'cart';
                }
              }).fail(function (e) {
                result.error = i18n.t('connection_error_notify');
              }).always(function () {
                resultCallback(result)
              })
            } else {
              result.success = true;
              result.type = 'cart';
              resultCallback(result);
            }
          } else {
            result.error = i18n.t('buy_forbidden');
            resultCallback(result);
          }
        });
      } catch (e) {
        result.error = e.message;
        resultCallback(result);
      }
    },

    buyFreeSingleCoupon: function (productId, customerEmail, callback) {
      $.ajax({
        url: '/ajax/coupon/buyFreeSingleCoupon',
        type: 'POST',
        data: {
          form_key: takhfifan.formKey,
          product_id: productId,
          customer_email: customerEmail
        }
      }).done(function (data) {
        var result = {success: false, error: ''};
        if (data && data.code === 200 && data.message && data.message.code) {
          result.success = true;
          result.code = data.message.code;
        } else {
          result.error = i18n.t('coupon_code_read_error');
        }
        callback(result);
      }).fail(function () {
        callback({success: false, error: i18n.t('connection_error_notify')});
      });
    },
  });
});

